import React from 'react';

import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: 110
    }
}));

export default function SelectProductField(props) {
    const classes = useStyles();


    const { onFieldUpdated } = props;
    const fields = [
        { id: "barcode", label: "Barcode" },
        { id: "name", label: "Name" },
        { id: "size", label: "Size" },
        { id: "color", label: "Color" },
        { id: "brand", label: "Brand" },
        { id: "category", label: "Categories" },
        { id: "supplier", label: "Supplier " }
    ];

    const [fieldId, setFieldId] = React.useState(fields[0].id);

    const updateField = (event) => {
        setFieldId(event.target.value);

        if (onFieldUpdated) {
            onFieldUpdated(event.target.value);
        }
    };

    return (
        <FormControl className={classes.formControl}>
            {/* <InputLabel id="select-field-label">field</InputLabel> */}
            <Select
                labelId="select-field-label"
                id="select-field"
                value={fieldId}
                onChange={updateField}>

                {fields.map((field) => (
                    <MenuItem value={field.id} key={field.id}>{field.label}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
